import t, { useState as e, useMemo as n, Fragment as o } from "react";
import r from "prop-types";
import { Transition as i } from "react-transition-group";
import { css as a, cx as c } from "@leafygreen-ui/emotion";
import l from "@leafygreen-ui/portal";
import { usePopoverContext as s, usePopoverPortalContainer as u } from "@leafygreen-ui/leafygreen-provider";
import { useViewportSize as f, useMutationObserver as p, useObjectDependency as d, usePrevious as h, useIsomorphicLayoutEffect as g } from "@leafygreen-ui/hooks";
import { consoleOnce as m } from "@leafygreen-ui/lib";
import { jsx as w } from "@emotion/react";

function y(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, o);
  }

  return n;
}

function v(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? y(Object(n), !0).forEach(function (e) {
      b(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

function b(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

function P() {
  return P = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
      }
    }

    return t;
  }, P.apply(this, arguments);
}

function E(t, e) {
  if (null == t) return {};

  var n,
      o,
      r = function (t, e) {
    if (null == t) return {};
    var n,
        o,
        r = {},
        i = Object.keys(t);

    for (o = 0; o < i.length; o++) {
      n = i[o], e.indexOf(n) >= 0 || (r[n] = t[n]);
    }

    return r;
  }(t, e);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);

    for (o = 0; o < i.length; o++) {
      n = i[o], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
    }
  }

  return r;
}

function j(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

function O(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == n) return;
    var o,
        r,
        i = [],
        a = !0,
        c = !1;

    try {
      for (n = n.call(t); !(a = (o = n.next()).done) && (i.push(o.value), !e || i.length !== e); a = !0) {
        ;
      }
    } catch (t) {
      c = !0, r = t;
    } finally {
      try {
        a || null == n.return || n.return();
      } finally {
        if (c) throw r;
      }
    }

    return i;
  }(t, e) || S(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function C(t) {
  return function (t) {
    if (Array.isArray(t)) return x(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
  }(t) || S(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function S(t, e) {
  if (t) {
    if ("string" == typeof t) return x(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? x(t, e) : void 0;
  }
}

function x(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, o = new Array(e); n < e; n++) {
    o[n] = t[n];
  }

  return o;
}

var D,
    H,
    R,
    V,
    T,
    B,
    M,
    W,
    F = {
  Top: "top",
  Bottom: "bottom",
  Left: "left",
  Right: "right",
  CenterVertical: "center-vertical",
  CenterHorizontal: "center-horizontal"
},
    L = {
  Start: "start",
  Middle: "middle",
  End: "end",
  Fit: "fit"
};

function z(t) {
  var e = t.useRelativePositioning,
      n = t.spacing,
      o = t.align,
      r = t.justify,
      i = t.referenceElViewportPos,
      a = void 0 === i ? N : i,
      c = t.referenceElDocumentPos,
      l = void 0 === c ? N : c,
      s = t.contentElViewportPos,
      u = void 0 === s ? N : s,
      f = t.contentElDocumentPos,
      p = void 0 === f ? N : f,
      d = t.scrollContainer,
      h = t.windowHeight,
      g = void 0 === h ? window.innerHeight : h,
      m = t.windowWidth,
      w = void 0 === m ? window.innerWidth : m,
      y = d ? d.offsetWidth : w,
      b = d ? d.offsetHeight : g,
      P = {
    windowWidth: y,
    windowHeight: b,
    referenceElViewportPos: a,
    contentElViewportPos: u,
    spacing: n
  };
  if (0 === u.width && r !== L.Fit) return {
    align: o,
    justify: r,
    positionCSS: {
      left: 0,
      top: 0
    }
  };

  var E = function (t, e) {
    var n = e.spacing,
        o = e.windowWidth,
        r = e.windowHeight,
        i = e.contentElViewportPos,
        a = e.referenceElViewportPos;
    return [t].concat(C(et[t])).find(function (t) {
      return [F.Top, F.Bottom, F.CenterVertical].includes(t) ? tt({
        top: K({
          align: t,
          contentElPos: i,
          referenceElPos: a,
          spacing: n
        }),
        windowHeight: r,
        contentHeight: i.height
      }) : !![F.Left, F.Right, F.CenterHorizontal].includes(t) && _({
        left: Q({
          align: t,
          contentElPos: i,
          referenceElPos: a,
          spacing: n
        }),
        windowWidth: o,
        contentWidth: i.width
      });
    }) || t;
  }(o, P),
      j = function (t, e, n) {
    var o,
        r,
        i = n.spacing,
        a = n.windowWidth,
        c = n.windowHeight,
        l = n.contentElViewportPos,
        s = n.referenceElViewportPos,
        u = [t].concat(C(nt[t]));

    switch (e) {
      case F.Top:
      case F.Bottom:
      case F.CenterVertical:
        return null !== (o = u.find(function (t) {
          return _({
            contentWidth: t === L.Fit ? s.width : l.width,
            windowWidth: a,
            left: Q({
              contentElPos: l,
              referenceElPos: s,
              spacing: i,
              align: e,
              justify: t
            })
          });
        })) && void 0 !== o ? o : nt[t][0];

      case F.Left:
      case F.Right:
      case F.CenterHorizontal:
        return null !== (r = u.find(function (t) {
          return tt({
            contentHeight: t === L.Fit ? s.height : l.height,
            windowHeight: c,
            top: K({
              contentElPos: l,
              referenceElPos: s,
              spacing: i,
              align: e,
              justify: t
            })
          });
        })) && void 0 !== r ? r : nt[t][0];
    }
  }(r, E, P),
      O = function (t) {
    var e,
        n,
        o = t.align,
        r = t.justify,
        i = X[o],
        a = null !== (e = i.x) && void 0 !== e ? e : U[r],
        c = null !== (n = i.y) && void 0 !== n ? n : Z[r];
    return "".concat(a, " ").concat(c);
  }({
    align: E,
    justify: j
  }),
      S = function (t, e) {
    var n = .8;

    switch (t) {
      case F.Top:
        return "translate3d(0, ".concat(e, "px, 0) scale(").concat(n, ")");

      case F.Bottom:
        return "translate3d(0, -".concat(e, "px, 0) scale(").concat(n, ")");

      case F.Left:
        return "translate3d(".concat(e, "px, 0, 0) scale(").concat(n, ")");

      case F.Right:
        return "translate3d(-".concat(e, "px, 0, 0) scale(").concat(n, ")");

      case F.CenterHorizontal:
      case F.CenterVertical:
        return "scale(".concat(n, ")");
    }
  }(E, n);

  return e ? {
    align: E,
    justify: j,
    positionCSS: v(v({}, G({
      align: E,
      justify: j,
      referenceElDocumentPos: l,
      contentElDocumentPos: p,
      spacing: n
    })), {}, {
      transformOrigin: O,
      transform: S
    })
  } : {
    align: E,
    justify: j,
    positionCSS: v(v({}, J({
      align: E,
      justify: j,
      referenceElDocumentPos: l,
      contentElDocumentPos: p,
      spacing: n,
      windowHeight: b,
      windowWidth: y
    })), {}, {
      transformOrigin: O,
      transform: S
    })
  };
}

var N = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  height: 0,
  width: 0
},
    A = function A(t, e) {
  return Math.abs(t - e) < 1 ? t : e;
};

function I(t, e) {
  if (!t) return N;
  var n = t.getBoundingClientRect(),
      o = n.top,
      r = n.bottom,
      i = n.left,
      a = n.right,
      c = n.width,
      l = t.offsetHeight,
      s = t.offsetWidth,
      u = A(c, s);

  if (e) {
    var f = e.scrollTop,
        p = e.scrollLeft,
        d = e.getBoundingClientRect();
    return {
      top: o + f - d.top,
      bottom: r + f - d.bottom,
      left: i + p - d.left,
      right: a + p - d.right,
      height: l,
      width: u
    };
  }

  var h = window,
      g = h.scrollX,
      m = h.scrollY;
  return {
    top: o + m,
    bottom: r + m,
    left: i + g,
    right: a + g,
    height: l,
    width: u
  };
}

function k(t, e) {
  if (!t) return N;
  var n = t.getBoundingClientRect(),
      o = n.top,
      r = n.bottom,
      i = n.left,
      a = n.right,
      c = n.width,
      l = t.offsetHeight,
      s = t.offsetWidth,
      u = A(c, s);

  if (e) {
    var f = e.getBoundingClientRect();
    return {
      top: o - f.top,
      bottom: r - f.bottom,
      left: i - f.left,
      right: a - f.right,
      height: l,
      width: u
    };
  }

  return {
    top: o,
    bottom: r,
    left: i,
    right: a,
    height: l,
    width: u
  };
}

var Z = (b(D = {}, L.Start, "top"), b(D, L.Middle, "center"), b(D, L.End, "bottom"), b(D, L.Fit, "center"), D),
    U = (b(H = {}, L.Start, "left"), b(H, L.Middle, "center"), b(H, L.End, "right"), b(H, L.Fit, "center"), H),
    X = (b(R = {}, F.Left, {
  x: "right"
}), b(R, F.Right, {
  x: "left"
}), b(R, F.Top, {
  y: "bottom"
}), b(R, F.Bottom, {
  y: "top"
}), b(R, F.CenterHorizontal, {
  x: "center"
}), b(R, F.CenterVertical, {
  y: "center"
}), R);
var Y = (b(V = {}, L.Start, {
  top: 0
}), b(V, L.End, {
  bottom: 0
}), b(V, L.Middle, function (t) {
  var e = t.contentElDocumentPos,
      n = t.referenceElDocumentPos;
  return {
    top: "".concat(n.height / 2 - e.height / 2, "px")
  };
}), b(V, L.Fit, {
  top: 0,
  bottom: 0
}), V),
    $ = (b(T = {}, L.Start, {
  left: 0
}), b(T, L.End, {
  right: 0
}), b(T, L.Middle, function (t) {
  var e = t.contentElDocumentPos,
      n = t.referenceElDocumentPos;
  return {
    left: "".concat(n.width / 2 - e.width / 2, "px")
  };
}), b(T, L.Fit, {
  left: 0,
  right: 0
}), T),
    q = (b(B = {}, F.Top, {
  constant: function constant(t) {
    var e = t.spacing;
    return {
      bottom: "calc(100% + ".concat(e, "px)")
    };
  },
  justifyPositions: $
}), b(B, F.Bottom, {
  constant: function constant(t) {
    var e = t.spacing;
    return {
      top: "calc(100% + ".concat(e, "px)")
    };
  },
  justifyPositions: $
}), b(B, F.CenterVertical, {
  constant: function constant(t) {
    var e = t.referenceElDocumentPos;
    return {
      top: "calc(".concat(e.height / 2, "px - 50%)")
    };
  },
  justifyPositions: $
}), b(B, F.Left, {
  constant: function constant(t) {
    var e = t.spacing;
    return {
      right: "calc(100% + ".concat(e, "px)")
    };
  },
  justifyPositions: Y
}), b(B, F.Right, {
  constant: function constant(t) {
    var e = t.spacing;
    return {
      left: "calc(100% + ".concat(e, "px)")
    };
  },
  justifyPositions: Y
}), b(B, F.CenterHorizontal, {
  constant: function constant(t) {
    var e = t.referenceElDocumentPos;
    return {
      left: "calc(".concat(e.width / 2, "px - 50%)")
    };
  },
  justifyPositions: Y
}), B);

function G(t) {
  var e,
      n = t.align,
      o = t.justify,
      r = t.referenceElDocumentPos,
      i = t.contentElDocumentPos,
      a = t.spacing,
      c = q[n],
      l = c.justifyPositions[o],
      s = {
    contentElDocumentPos: i,
    referenceElDocumentPos: r,
    spacing: a
  };
  return v(v({}, null === (e = c.constant) || void 0 === e ? void 0 : e.call(c, s)), "function" == typeof l ? l(s) : l);
}

function J(t) {
  var e = t.align,
      n = t.justify,
      o = t.referenceElDocumentPos,
      r = t.contentElDocumentPos,
      i = t.spacing,
      a = t.windowWidth,
      c = t.windowHeight,
      l = Q({
    align: e,
    justify: n,
    referenceElPos: o,
    contentElPos: r,
    spacing: i
  }),
      s = "".concat(l, "px"),
      u = "".concat(K({
    align: e,
    justify: n,
    referenceElPos: o,
    contentElPos: r,
    spacing: i
  }), "px");
  return n !== L.Fit ? {
    left: s,
    top: u
  } : [F.Left, F.Right, F.CenterHorizontal].includes(e) ? {
    left: s,
    top: u,
    bottom: "".concat(c - o.bottom, "px")
  } : {
    left: s,
    top: u,
    right: "".concat(a - (l + o.width), "px")
  };
}

function K(t) {
  var e = t.align,
      n = t.justify,
      o = t.contentElPos,
      r = t.referenceElPos,
      i = t.spacing;

  switch (e) {
    case F.Left:
    case F.Right:
    case F.CenterHorizontal:
      switch (n) {
        case L.Start:
        case L.Fit:
          return r.top;

        case L.End:
          return r.top + r.height - o.height;

        default:
          return r.top - (o.height - r.height) / 2;
      }

    case F.CenterVertical:
      return r.top - (o.height - r.height) / 2;

    case F.Top:
      return r.top - o.height - i;

    case F.Bottom:
    default:
      return r.top + r.height + i;
  }
}

function Q(t) {
  var e = t.align,
      n = t.justify,
      o = t.contentElPos,
      r = t.referenceElPos,
      i = t.spacing;

  switch (e) {
    case F.Top:
    case F.Bottom:
    case F.CenterVertical:
      switch (n) {
        case L.End:
          return r.left + r.width - o.width;

        case L.Middle:
          return r.left - (o.width - r.width) / 2;

        default:
          return r.left;
      }

    case F.Left:
      return r.left - o.width - i;

    case F.Right:
      return r.left + r.width + i;

    case F.CenterHorizontal:
    default:
      return r.left - (o.width - r.width) / 2;
  }
}

function _(t) {
  var e = t.left,
      n = t.windowWidth,
      o = t.contentWidth;
  return e >= 0 && !(e + o > n);
}

function tt(t) {
  var e = t.top,
      n = t.windowHeight,
      o = t.contentHeight;
  return e >= 0 && !(e + o > n);
}

var et = (b(M = {}, F.Top, [F.Bottom]), b(M, F.Bottom, [F.Top]), b(M, F.Left, [F.Right]), b(M, F.Right, [F.Left]), b(M, F.CenterHorizontal, [F.Left, F.Right]), b(M, F.CenterVertical, [F.Top, F.Bottom]), M);
var nt = (b(W = {}, L.Start, [L.End, L.Middle]), b(W, L.Middle, [L.End, L.Start]), b(W, L.End, [L.Start, L.Middle]), b(W, L.Fit, [L.Middle, L.Start, L.End]), W);
var ot,
    rt,
    it,
    at,
    ct = ["active", "spacing", "align", "justify", "adjustOnMutation", "children", "className", "popoverZIndex", "refEl", "usePortal", "portalClassName", "portalContainer", "scrollContainer"],
    lt = ["transform"],
    st = a(ot || (ot = j(["\n  position: absolute;\n  transition: transform 150ms ease-in-out, opacity 150ms ease-in-out;\n  opacity: 0;\n"]))),
    ut = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
};

function ft(r) {
  var y = r.active,
      v = void 0 !== y && y,
      C = r.spacing,
      S = void 0 === C ? 10 : C,
      x = r.align,
      D = void 0 === x ? F.Bottom : x,
      H = r.justify,
      R = void 0 === H ? L.Start : H,
      V = r.adjustOnMutation,
      T = void 0 !== V && V,
      B = r.children,
      M = r.className,
      W = r.popoverZIndex,
      N = r.refEl,
      A = r.usePortal,
      Z = void 0 === A || A,
      U = r.portalClassName,
      X = r.portalContainer,
      Y = r.scrollContainer,
      $ = E(r, ct),
      q = O(e(null), 2),
      G = q[0],
      J = q[1],
      K = O(e(null), 2),
      Q = K[0],
      _ = K[1],
      tt = O(e(0), 2),
      et = tt[0],
      nt = tt[1],
      ot = s().setIsPopoverOpen,
      ft = u(),
      pt = ft.portalContainer,
      dt = ft.scrollContainer;
  pt = X || pt, dt = Y || dt, Z && dt && (dt.contains(pt) || m.warn("To ensure correct positioning make sure that the portalContainer element is inside of the scrollContainer"));
  var ht = t.useRef(Q);
  ht.current = Q;
  var gt = null;
  if (N && N.current) gt = N.current;else if (G) {
    var mt = G.parentNode;
    mt && mt instanceof HTMLElement && (gt = mt);
  }
  var wt = f(),
      yt = T && v,
      vt = p(gt, ut, Date.now, yt),
      bt = p(Q, ut, Date.now, yt),
      Pt = d(k(gt, dt)),
      Et = d(k(Q, dt)),
      jt = d(n(function () {
    return I(gt, dt);
  }, [gt, dt, wt, vt, v, D, R, et])),
      Ot = d(n(function () {
    return I(Q);
  }, [Q, wt, bt, v, D, R, et])),
      Ct = h(R),
      St = h(D),
      xt = Ct !== R && (R === L.Fit || Ct === L.Fit) || St !== D && R === L.Fit;
  g(function () {
    xt && nt(function (t) {
      return t + 1;
    });
  }, [xt]);
  var Dt = O(e(!1), 2),
      Ht = Dt[0],
      Rt = Dt[1];
  if (g(function () {
    return Rt(!0);
  }, []), !Ht) return null;
  var Vt,
      Tt = z({
    useRelativePositioning: !Z,
    spacing: S,
    align: D,
    justify: R,
    referenceElViewportPos: Pt,
    referenceElDocumentPos: jt,
    contentElViewportPos: Et,
    contentElDocumentPos: Ot,
    scrollContainer: dt
  }),
      Bt = Tt.align,
      Mt = Tt.justify,
      Wt = Tt.positionCSS,
      Ft = Wt.transform,
      Lt = E(Wt, lt),
      zt = a(rt || (rt = j(["\n    opacity: 1;\n    position: ", ";\n    pointer-events: initial;\n  "])), Z ? "" : "absolute"),
      Nt = Z ? l : o,
      At = Z ? pt ? {
    container: pt
  } : {
    className: null != U ? U : void 0
  } : {};
  return Vt = null == B ? null : "function" == typeof B ? B({
    align: Bt,
    justify: Mt,
    referenceElPos: jt
  }) : B, w(i, {
    nodeRef: ht,
    in: v,
    timeout: 150,
    mountOnEnter: !0,
    unmountOnExit: !0,
    appear: !0,
    onEntered: function onEntered() {
      return ot(!0);
    },
    onExit: function onExit() {
      return ot(!1);
    }
  }, function (e) {
    var n;
    return w(t.Fragment, null, w("div", {
      ref: J,
      className: a(it || (it = j(["\n              display: none;\n            "])))
    }), w(Nt, At, w("div", P({}, $, {
      className: c(st, a(Lt), (n = {}, b(n, a({
        transform: Ft
      }), "entering" === e || "exiting" === e), b(n, zt, "entered" === e), b(n, a(at || (at = j(["\n                    z-index: ", ";\n                  "])), W), "number" == typeof W), n), M)
    }), w("div", {
      ref: _
    }, Vt))));
  });
}

ft.displayName = "Popover", ft.propTypes = {
  children: r.oneOfType([r.node, r.func]),
  active: r.bool,
  className: r.string,
  align: r.oneOf(Object.values(F)),
  justify: r.oneOf(Object.values(L)),
  refEl: r.shape({
    current: "undefined" != typeof window ? r.instanceOf(Element) : r.any
  }),
  usePortal: r.bool,
  portalClassName: r.string,
  spacing: r.number,
  adjustOnMutation: r.bool
};
export { F as Align, L as Justify, ft as default };